import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Commande de voucher Ogloba")
], -1)
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "search-container" }
const _hoisted_4 = { class: "card-body pt-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "Actions", -1)

import Column from "primevue/column";
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import { ref, onMounted } from "vue";
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";

const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'ListOglobaOrder',
  setup(__props) {

const page = ref < number > (1);
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
let rows = ref<number>(10);
const isLoading = ref<boolean>(true);
const vouchers = Array<Document>();
let tableData = ref<Array<Document>>(vouchers);
let currentPage = ref<number>(0);
let totalRecords = ref<number>(0);


onMounted(async () => {
    await populateDatatable(rows.value, page.value);
});

const populateDatatable = async (itemsPerPage: number, page: number) => {
     await fetchData(itemsPerPage, page);
};

async function fetchData(
    itemsPerPage: number,
    page: number
) {
    const params = {
        itemsPerPage: itemsPerPage,
        page: page,
    }
    try {
        const { data } = await ApiService.get('admin/get-ogloba-voucher-created-by-admin', {
            headers: { Accept: 'application/ld+json' },
            params: params
        });
        totalRecords.value = data.data['hydra:totalItems'];
        tableData.value=[];
        data.data['hydra:member'].forEach((item) => {
            tableData.value.push(item);
        });
    } catch (error) {
        swal.error('An error occurred while fetching vouchers.');
    }
    isLoading.value = false;
}

const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    isLoading.value =true;
    await populateDatatable(e.rows, e.page + 1);
};


function getLabelStatus(status: string): string {
    switch (status) {
        case 'CONFIRMED':
            return 'Confirmé';
        case 'RESERVED':
            return 'Créé';
        case 'SENDED':
            return 'Envoyé';
        case 'READY':
            return 'Prêt';
        default:
            return status;
    }
}

async function downloadVoucher(voucherUuid, voucherRef) {
    try {
        ApiService.get(`/customer/order/document/${voucherUuid}`,
            {responseType: 'blob'}
        ).then(response => {
            const blob = new Blob([response.data], {type: 'application/pdf'})
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = voucherRef
            link.click()
            URL.revokeObjectURL(link.href)
        })
    } catch (error) {
        swal.error();
    }
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DataTable), {
        value: _unref(tableData),
        rows: _unref(rows),
        paginator: true,
        loading: isLoading.value,
        rowsPerPageOptions: rowsPerPageOptions,
        lazy: "",
        onPage: onPaginate,
        currentPage: _unref(currentPage),
        totalRecords: _unref(totalRecords)
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              class: "group inline-flex items-center justify-center rounded-full py-2 px-4 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-blue-600 text-white hover:text-slate-100 hover:bg-blue-500 active:bg-blue-800 active:text-blue-100 focus-visible:outline-blue-600",
              to: "/admin/catalogue/create-ogloba-order"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Commander un voucher ")
              ]),
              _: 1
            })
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun résultat trouvé.")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Column), {
              field: "createdAt",
              header: "Date"
            }),
            _createVNode(_unref(Column), {
              field: "voucherRef",
              header: "Référence voucher"
            }),
            _createVNode(_unref(Column), {
              field: "productName",
              header: "Nom du produit"
            }),
            _createVNode(_unref(Column), {
              field: "faceValue",
              header: "Valeur faciale"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.faceValue + ' €'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "state",
              header: "Etat du voucher"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(getLabelStatus(slotProps.data.state)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "createdBy",
              header: "Utilisateur"
            }),
            _createVNode(_unref(Column), { headerStyle: "width: 12em;" }, {
              header: _withCtx(() => [
                _hoisted_5
              ]),
              body: _withCtx((slotProps) => [
                (slotProps.data.giftCardUrl !== '')
                  ? (_openBlock(), _createBlock(_unref(Button), {
                      key: 0,
                      size: "small",
                      icon: "pi pi-download",
                      class: "p-button-success",
                      style: {"margin-right":"0.5em"},
                      title: "Télécharger le voucher",
                      onClick: ($event: any) => (downloadVoucher(slotProps.data.uuid, slotProps.data.voucherRef))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "loading", "currentPage", "totalRecords"])
    ])
  ], 64))
}
}

})